import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaEye, FaRegFileExcel } from 'react-icons/fa6';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import AddDocument from './AddDocument';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';
import Select from 'react-select';
import NumberFormat from '../../components/NumberFormat';
import { FaBan, FaCheck } from 'react-icons/fa';
import ShowDocument from './ShowDocument';


const Documents = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [showAddDocument, setShowAddDocument] = useState(false);
    const [showDocument, setShowDocument] = useState(false);
    const [auteurs, setCaisseCenrales] = useState([]);
    const [selectedAuteur, setSelectedAuteur] = useState(null);
    const [inputValueAuteur, setValueAuteur] = useState('');
    const [selectedDocument, setSelectedDocument] = useState(null);

    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [req, setReq] = useState({
        DateDebut: '',
        DateFin: '',
        auteur: '',

    });
    const navigate = useNavigate();

    const supprimer = (document) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/document/' + document.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getDocuments();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    const handleInputChangeAuteur = value => {
        setValueAuteur(value);
    };

    // handle selection


    // handle selection
    const handleChangeAuteur = value => {
        setSelectedAuteur(value);
        setReq({ ...req, auteur: value.id });

    }

    useEffect(() => {
        if (user.role != null && (user.role.name === 'admin' || user.role.name === 'controleur')) {
            getAuteurs();
        }
    }, [])

    const getAuteurs = () => {
        axiosClient.get('/auteurs')
            .then((data) => {
                setCaisseCenrales(data.data.users);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const closeAddDocument = () => {
        setShowAddDocument(false);
    }
    const closeShowDocument = () => {
        setShowDocument(false);
        setSelectedDocument(null);
    }
    const getDocuments = () => {
        setLoading(true);
        axiosClient.get('/documents?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin + '&auteur=' + req.auteur)
            .then(response => {
                setDocuments(response.data.documents);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const valider = (document) => {
        axiosClient.put('/validerDocument/' + document.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const annuler = (document) => {
        axiosClient.put('/annulerDocument/' + document.id)
            .then((data) => {
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header title="Documents" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
                <Input label="Date debut" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
                <Input label="Date fin" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />
                {user.role && (user.role.name === 'admin' || user.role.name === 'controleur') ?
                    <div className="flex-col w-full">
                        <label className="block text-sm font-medium leading-6 text-gray-900">Auteur <span className='text-red-500'> *</span></label>
                        <Select className='mt-1 outline-1 ' placeholder="Caisse Centrale" cacheOptions defaultOptions value={selectedAuteur} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={auteurs} onInputChange={handleInputChangeAuteur} onChange={handleChangeAuteur} />
                    </div>
                    :
                    <></>
                }
                <div className=' flex gap-2 mt-8'>
                    <Button onClick={() => getDocuments()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                    <DownloadTableExcel
                        filename="Documents"
                        sheet="documents"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />
                    </DownloadTableExcel>
                </div>
            </div>

            <div className="flex my-4">
                <Button onClick={() => setShowAddDocument(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
            </div>


            
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>Numéro</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Titre</th>
                            <th>Auteur</th>
                            <th>Création</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="7"><Loading /></td></tr></tbody> :
                        <tbody>
                            {documents.map(o => (
                                <tr key={o.id}>
                                    <td>{o.num}</td>
                                    <td>{o.dateDocument}</td>
                                    <td>{o.type.code}</td>
                                    <td>{o.titre}</td>
                                    <td>{o.auteur.nom}</td>
                                    <td>{o.created_at}</td>
                                    <td>
                                        <div className="flex gap-2">
                                            
                                            <ActionButton onClick={() => {
                                                setSelectedDocument(o);
                                                setShowDocument(true);
                                            }} color="bg-blue-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                            {user.role && user.role.name === 'admin' ?
                                                <>
                                                    {o.valide === false ?
                                                        <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                                                        :
                                                        <></>
                                                    }
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    }
                </table>
            </div>
            {
                showAddDocument ? <AddDocument onClose={closeAddDocument} /> : <></>
            }
            {
                showDocument ? <ShowDocument document={selectedDocument} onClose={closeShowDocument} /> : <></>
            }

        </>
    )
}

export default Documents